'use client';

import { getClassNames } from '@websolutespa/bom-core';
import { useAutosizeTextArea, useLabel } from '@websolutespa/bom-mixer-hooks';
import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';
import style from './page-textarea.module.scss';

export const PageTextarea: React.FC = () => {
  const label = useLabel();
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const app = useLlm(state => state.app);
  const prompt = useLlm(state => state.prompt);
  const streaming = useLlm(state => state.streaming);
  const { setPrompt, clear } = useLlm(state => state.actions);
  const { send } = useLlmView(state => state.actions);

  useAutosizeTextArea(textAreaRef.current, prompt);

  const onSubmit = async (event?: React.FormEvent) => {
    event && event.preventDefault();
    if (!prompt) {
      return;
    }
    clear();
    await send(prompt, (response) => {
      // console.log('PagePrompt.onChunk', response.chunks);
    }, (response) => {
      // console.log('PagePrompt.onEnd', response);
    });
  };

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const prompt = event.target?.value;
    setPrompt(prompt);
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.code == 'Enter' && !event.shiftKey && !streaming) {
      onSubmit(event);
    }
  };

  return (
    <>
      <label
        className={getClassNames(style.label)}
        htmlFor="llm-page-prompt__textarea"
      >{label('llm.prompt')}</label>
      <textarea
        className={getClassNames(style.textarea, '-textarea')}
        ref={textAreaRef}
        id="llm-page-prompt__textarea"
        name="prompt"
        placeholder={app?.contents.promptPlaceholder}
        value={prompt}
        rows={1}
        aria-disabled={streaming}
        onKeyDown={onKeyDown}
        onChange={onChange}
      ></textarea>
    </>
  );
};
